import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../design/tokens';
import { SocialSettings } from '../../types';
import { FiSave, FiPhone, FiMail } from 'react-icons/fi';

const Section = styled.section`
  background: ${tokens.colors.adminSurface};
  border-radius: 12px;
  padding: ${tokens.spacing.lg};
  margin-bottom: ${tokens.spacing.lg};
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${tokens.spacing.lg};
  padding-bottom: ${tokens.spacing.sm};
  border-bottom: 1px solid ${tokens.colors.adminBorder};
`;

const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${tokens.colors.adminText};
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.md};
`;

const ContactForm = styled.div`
  padding: ${tokens.spacing.lg};
`;

const FormGroup = styled.div`
  margin-bottom: ${tokens.spacing.xl};
`;

const FormLabel = styled.label`
  display: block;
  font-weight: 600;
  color: ${tokens.colors.adminText};
  margin-bottom: ${tokens.spacing.sm};
`;

const FormInput = styled.input`
  width: 100%;
  padding: ${tokens.spacing.md};
  border: 1px solid ${tokens.colors.adminBorder};
  border-radius: 6px;
  font-size: 14px;
  background: ${tokens.colors.adminSurface};
  color: ${tokens.colors.adminText};
  &:focus {
    outline: none;
    border-color: ${tokens.colors.adminAccent};
  }
`;

const FormActions = styled.div`
  display: flex;
  gap: ${tokens.spacing.md};
  justify-content: flex-end;
  margin-top: ${tokens.spacing.xl};
`;

const SaveBtn = styled.button`
  background: ${tokens.colors.adminAccent};
  color: white;
  border: none;
  padding: ${tokens.spacing.md} ${tokens.spacing.xl};
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.sm};
  &:hover {
    background: #7a04b8;
  }
`;

interface AdminContactSettingsProps {
  settings: Partial<SocialSettings>;
  onUpdate: (settings: Partial<SocialSettings>) => void;
  onSave: () => void;
}

const AdminContactSettings: React.FC<AdminContactSettingsProps> = ({ settings, onUpdate, onSave }) => {
  return (
    <Section>
      <SectionHeader>
        <SectionTitle>
          {React.createElement(FiPhone as any, { size: 24 })}
          Información de Contacto
        </SectionTitle>
      </SectionHeader>
      <ContactForm>
        <FormGroup>
          <FormLabel>Número WhatsApp</FormLabel>
          <FormInput
            type="tel"
            value={settings.whatsapp_contact || ''}
            onChange={(e) => onUpdate({ ...settings, whatsapp_contact: e.target.value })}
            placeholder="5511999999999"
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>E-mail de Contato</FormLabel>
          <FormInput
            type="email"
            value={settings.contact_email || ''}
            onChange={(e) => onUpdate({ ...settings, contact_email: e.target.value })}
            placeholder="contato@cafetutoriales.com"
          />
        </FormGroup>

        <FormActions>
          <SaveBtn onClick={onSave}>
            {React.createElement(FiSave as any, { size: 16 })}
            Guardar Cambios
          </SaveBtn>
        </FormActions>
      </ContactForm>
    </Section>
  );
};

export default AdminContactSettings;
